module.exports = __webpack_public_path__ + "static/media/Reportdefault.24c2db24.png";